import { useLang } from "../../i18n/LangContext";
import { useSettings } from "../../context/SettingsContext";
import { SERVICES } from "../../data/services";

export const StepService = ({ draft, update, errors }) => {
  const { t } = useLang();
  const { settings } = useSettings();
  const list = SERVICES.filter((s) => settings.enabled_services.includes(s.id));
  return (
    <fieldset>
      <legend className="text-2xl sm:text-3xl font-extrabold uppercase">{t("wizard.chooseService")}</legend>
      {errors.service_id && <p role="alert" className="mt-2 text-sm text-red-400" data-testid="service_id-error">{t(errors.service_id)}</p>}
      <div role="radiogroup" className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
        {list.map((s) => {
          const Icon = s.icon;
          const [name, desc] = t(`services.${s.id}`);
          const sel = draft.service_id === s.id;
          return (
            <button
              key={s.id}
              type="button"
              role="radio"
              aria-checked={sel}
              data-testid={`wizard-service-${s.id}`}
              onClick={() => update("service_id", s.id)}
              className={`flex items-start gap-4 rounded-xl border p-4 text-left transition-colors ${sel ? "border-[#FACC15] bg-[#FACC15]/10" : "border-[#2E2E3A] bg-[#0E0E12] hover:border-gray-500"}`}
            >
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${sel ? "bg-[#FACC15] text-black" : "bg-[#DC2626]/15 text-[#DC2626]"}`}>
                <Icon className="h-5 w-5" aria-hidden="true" />
              </span>
              <span>
                <span className={`block font-bold ${sel ? "text-[#FACC15]" : "text-white"}`}>{name}</span>
                <span className="mt-0.5 block text-xs text-gray-400">{desc}</span>
              </span>
            </button>
          );
        })}
      </div>
    </fieldset>
  );
};
